// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_f8731108"};